import { render, staticRenderFns } from "./Depots.vue?vue&type=template&id=65855ce3"
import script from "./Depots.vue?vue&type=script&lang=js"
export * from "./Depots.vue?vue&type=script&lang=js"
import style0 from "./Depots.vue?vue&type=style&index=0&id=65855ce3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports